import { isEmpty } from 'lodash'
import AccountApi from '@/api/account'

const SET_PLAN_MUTATION = 'setPlan'

const _state = {
  salesAssistedContract: null,
}

const actions = {
  getSalesAssistedContractData: async ({ commit, rootState }) => {
    const { plan, currentUser } = rootState
    const isFreePlan = plan?.group === 'free'
    const isInTeam = currentUser?.accountId
    // check if user is free plan or not in team
    if (isFreePlan || !isInTeam) return
    const salesAssistedContract = await AccountApi.getSalesAssistedContract()
    commit('setSalesAssistedContract', salesAssistedContract)
  },
}

const _getters = {
  canUseNewBadgeComponent: (_, __, ___, rootGetters) => {
    return rootGetters['featureToggles/isFeatureEnabled']('release-new-plan-badge-component')
  },
  isEnterprise: (state, getters) => {
    if (!getters.canUseNewBadgeComponent) return false
    return !isEmpty(state.salesAssistedContract)
  },
}

const mutations = {
  setSalesAssistedContract(state, payload) {
    state.salesAssistedContract = payload
  },
}

const plugin = (store) => {
  store.subscribe((mutation) => {
    // WHY SET_PLAN?
    // Because the setPlan is always called after setCurrentUser mutation
    // the flow is currentUser -> plan -> salesAssistedContract data
    if (mutation.type !== SET_PLAN_MUTATION) return
    store.dispatch('planModule/getSalesAssistedContractData')
  })
}

export default {
  namespaced: true,
  state: _state,
  actions,
  mutations,
  getters: _getters,
  plugin,
}
